<template>
  <FilterSingleChip
    icon="eye"
    :is-text="isText"
    :label="label || $t('search-filters.action-filters.read')"
    :items="items"
    :value="value && value.length ? value[0] : null"
    @change="onChange"
  />
</template>

<script>
import FilterSingleChip from '@/components/filters/FilterSingleChip';
import { READ_FILTERS_VALUES } from '@/models/search-filters';

/**
 * Read-status dimension chip (read / unread). A single choice, but stored as an array
 * (readFilters) to match the search-filters model — so this chip adapts array↔value around a
 * single-select FilterSingleChip. Presentational: `:value` (array) in, `change` (0/1 array) out.
 */
export default {
  name: 'ReadChip',
  components: { FilterSingleChip },
  props: {
    value: { type: Array, default: () => [] },
    // Optional label override (defaults to the shared "Read" label).
    label: { type: String, default: null },
    // Show the dimension name on the chip face (used in the compact stacked filters dialog).
    isText: { type: Boolean, default: false },
  },
  computed: {
    items() {
      return READ_FILTERS_VALUES.map((value) => ({
        value,
        text: this.$t(`search-filters.action-filters.values.${value}`),
      }));
    },
  },
  methods: {
    onChange(next) {
      this.$emit('change', next == null ? [] : [next]);
    },
  },
};
</script>
